import Step0 from '@/components/Step0.vue'
import Step1 from '@/components/Step1.vue'
import Step2 from '@/components/Step2.vue'
import Step3 from '@/components/Step3.vue'
import Step4 from '@/components/Step4.vue'
import Step5 from '@/components/Step5.vue'
import Step6 from '@/components/Step6.vue'
import Step7 from '@/components/Step7.vue'
import Step8 from '@/components/Step8.vue'

const routes = [
	{ path: '/', name: 'index', component: Step0 },
	{ path: '/check-eligibility', name: 'check-eligibility', component: Step1 },
	{ path: '/farm-details', name: 'farm-details', component: Step2 },
	{ path: '/finance-details', name: 'finance-details', component: Step3 },
	{ path: '/your-details', name: 'your-details', component: Step4 },
	{ path: '/thanks-for-applying', name: 'declined', component: Step5 },
	{ path: '/dd-thanks-for-applying', name: 'dd-declined', component: Step5 },
	{ path: '/referred', name: 'referred', component: Step6 },
	{ path: '/dd-referred', name: 'dd-referred', component: Step6 },
	{ path: '/great-news', name: 'success', component: Step7 },
	{ path: '/dd-great-news', name: 'dd-success', component: Step7 },
	{ path: '/approved', name: 'approved', component: Step8 },
	{ path: '/approved', name: 'dd-approved', component: Step8 }
];

export default routes